import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVtex = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 32,
	viewBox: "0 0 38 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M34.6448 0.00011968H6.67979C5.66786 0.00937127 4.73372 0.54474 4.2142 1.41318C3.69469 2.28163 3.66473 3.35789 4.13512 4.25389L6.93396 9.58278H1.86216C1.2142 9.57099 0.608386 9.90299 0.269674 10.4555C-0.069038 11.008 -0.0900616 11.6985 0.21441 12.2706L9.21277 29.274C9.53566 29.8846 10.1698 30.2666 10.8605 30.2666C11.5513 30.2666 12.1854 29.8846 12.5083 29.274L14.9507 24.6667L18.0183 30.4689C18.5171 31.4109 19.4956 32 20.5615 32C21.6274 32 22.6059 31.4109 23.1047 30.4689L37.1281 4.10197C37.5924 3.2341 37.5646 2.18568 37.0548 1.3437C36.5451 0.501711 35.629 -0.00898293 34.6448 0.00011968ZM22.1494 11.14L16.0141 22.645C15.8033 23.0424 15.3903 23.2909 14.9405 23.2909C14.4906 23.2909 14.0776 23.0424 13.8668 22.645L7.81042 11.251C7.62357 10.9003 7.63448 10.4773 7.83917 10.1368C8.04385 9.79626 8.41227 9.58815 8.80959 9.58863H21.2028C21.5762 9.58288 21.9248 9.77503 22.1193 10.0938C22.3139 10.4126 22.3253 10.8105 22.1494 11.14Z",
		fill: "#FF3366"
	})]
});
const ForwardRef = forwardRef(SvgVtex);
export { ForwardRef as ReactComponent };
